
import React, { Component, ErrorInfo, ReactNode } from"react";
import { AlertCircle } from"lucide-react";
import * as Sentry from"@sentry/react";

interface Props {
 children: ReactNode;
 fallback?: ReactNode;
 sectionName?: string;
}

interface State {
 hasError: boolean;
 error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
 public state: State = {
 hasError: false,
 error: null,
 };

 public static getDerivedStateFromError(error: Error): State {
 return { hasError: true, error };
 }

 public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
 console.error(`ErrorBoundary caught error in ${this.props.sectionName ||"component"}:`, error, errorInfo);
 Sentry.captureException(error, { extra: { componentStack: errorInfo.componentStack, section: this.props.sectionName } });
 }

 public render() {
 if (this.state.hasError) {
 if (this.props.fallback) {
 return this.props.fallback;
 }

 return (
 <div className="bg-white border border-[#E8E4DB] rounded-lg p-4 my-4 animate-in fade-in">
 <div className="flex items-start gap-3">
 <AlertCircle className="w-5 h-5 text-[#1A1A1A] mt-0.5 flex-shrink-0" />
 <div>
 <h3 className="text-sm font-bold text-[#1A1A1A]">Something went wrong</h3>
 <p className="text-xs text-[#1A1A1A] mt-1">
 We couldn't display the {this.props.sectionName ||"content"}.
 </p>
 {this.state.error && (
 <details className="mt-2 text-[10px] text-[#1A1A1A] font-mono cursor-pointer">
 <summary>View Error Details</summary>
 <pre className="mt-1 whitespace-pre-wrap">{this.state.error.message}</pre>
 </details>
 )}
 </div>
 </div>
 </div>
 );
 }

 return this.props.children;
 }
}
